import type { UserLogoutAuthenticator } from '@usecases/user-logout.usecase';
import { BUS_IFRAME_ELM_ID } from '@main/config/bus.config';
import { BusAuthentication } from '@main/bus-layer/bus-authentication';

export class BusUserLogoutAuthenticator implements UserLogoutAuthenticator {
  private static Ins: BusUserLogoutAuthenticator;

  constructor() {
    return (
      BusUserLogoutAuthenticator.Ins ?? (BusUserLogoutAuthenticator.Ins = this)
    );
  }

  async signOut(): Promise<void> {
    const target: HTMLIFrameElement = <HTMLIFrameElement>(
      document.getElementById(BUS_IFRAME_ELM_ID)
    );

    await BusAuthentication.logout(target);
  }
}
